import React, { useState } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { excluirVinculo } from '~/Services/Service';

const ModalConfirmarExclusao = ({
  show,
  vinculo,
  gePrincipal,
  contaPrincipal,
  onConfirmar,
  onFechar,
}) => {
  const [excluindo, setExcluindo] = useState(false);

  const handleConfirmar = () => {
    setExcluindo(true);
    excluirVinculo({
      codigo_ge_principal: gePrincipal,
      codigo_conta_principal: contaPrincipal,
      codigo_ge_vinculo: vinculo.ge_vinculo,
      codigo_conta_vinculo: vinculo.conta_vinculo,
    })
      .then(() => {
        toast.success('Vínculo excluído com sucesso!');
        onConfirmar();
      })
      .catch(err => {
        const msg = err && err.message ? err.message : 'Erro ao excluir vínculo';
        toast.error(msg);
      })
      .finally(() => setExcluindo(false));
  };

  return (
    <Modal show={show} onHide={onFechar} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar Exclusão</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          Deseja excluir o vínculo abaixo?
        </p>
        <Table bordered size="sm">
          <tbody>
            <tr>
              <th style={{ width: '40%' }}>GE / Conta</th>
              <td>
                {vinculo.ge_vinculo} / {vinculo.conta_vinculo}
              </td>
            </tr>
            <tr>
              <th>Apelido</th>
              <td>{vinculo.apelido_conta || '—'}</td>
            </tr>
            <tr>
              <th>Agência / Nº Conta</th>
              <td>
                {vinculo.agencia || '—'} / {vinculo.numero_conta || '—'}
              </td>
            </tr>
            <tr>
              <th>Convênio PG</th>
              <td>{vinculo.pg_convenio || '—'}</td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onFechar} disabled={excluindo}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleConfirmar} disabled={excluindo}>
          {excluindo ? 'Excluindo...' : 'Excluir'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmarExclusao;
